import React from "react";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { motion } from "framer-motion";
import "./Footer.css";

function Footer() {
  return (
    <motion.footer 
      className="footer"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <div className="footer-container" id="contact">

        {/* Brand Column */}
        <div className="footer-col">
          <h3 className="footer-logo">Dhanushdhari Renovators</h3>
          <p className="footer-desc">
            Building dreams, creating value.<br/>
            Your trusted partner in premium real estate.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-col">
          <h4 className="footer-heading">QUICK LINKS</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/">About Us</a></li>
            <li><a href="/">Projects</a></li>
            <li><a href="/">Contact Us</a></li>
          </ul>
        </div>

        {/* Legal */}
        <div className="footer-col">
          <h4 className="footer-heading">LEGAL</h4>
          <ul>
            <li><a href="/">Privacy Policy</a></li>
            <li><a href="/">Terms of Service</a></li>
            <li><a href="/">Disclaimer</a></li>
          </ul>
        </div>

        {/* Social */}
        <div className="footer-col">
          <h4 className="footer-heading">FOLLOW US</h4>
          <div className="social-icons">
            <a href="/"><FaFacebookF /></a>
            <a href="/"><FaTwitter /></a>
            <a href="/"><FaLinkedinIn /></a>
            <a href="/"><FaInstagram /></a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        © 2025 Dhanushdhari Renovators. All rights reserved.
      </div>
    </motion.footer>
  );
}

export default Footer;
